import { Tooltip } from "~/src/lib/tooltip"
import { domReady } from "../helpers"

const desktopMQ = window.matchMedia("(min-width: 640px)")

domReady(installTooltips)
desktopMQ.addEventListener("change", () => installTooltips())
addEventListener("include-fragment-replace", ({ detail }) => installTooltips(detail.fragment), { capture: true })

function installTooltips(root = document) {
  if (!desktopMQ.matches) return

  // Install tooltips
  for (const element of root.querySelectorAll("[data-tooltip],[data-tooltips] a[title]")) {
    Tooltip.install(element)
  }

  // Install popovers
  for (const element of root.querySelectorAll("[data-popover]")) {
    const target = element.querySelector("[data-popover-content]")
    if (target) Tooltip.install(element, { target, type: "popover" })
  }
}
